import { render } from "./PlayTCPAButton.vue?vue&type=template&id=4d3da96d"
import script from "./PlayTCPAButton.vue?vue&type=script&lang=js"
export * from "./PlayTCPAButton.vue?vue&type=script&lang=js"

import "./PlayTCPAButton.vue?vue&type=style&index=0&id=4d3da96d&lang=scss"
script.render = render

export default script